module.exports = __webpack_public_path__ + "img/06.1705e5ec.jpg";